import type { EditorNode, MapEdit } from "./mapEdit.js";

function isBoss(node: EditorNode): boolean {
  return node.kind === "case" && node.size === "boss";
}

function reachableFrom(nodes: Record<string, EditorNode>, startId: string): Set<string> {
  const seen = new Set<string>();
  const stack = [startId];
  while (stack.length > 0) {
    const id = stack.pop();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    const node = nodes[id];
    if (node) stack.push(...node.next);
  }
  return seen;
}

function idsMissing(list: EditorNode[], seen: Set<string>): string[] {
  return list.filter((node) => !seen.has(node.id)).map((node) => node.id);
}

export function validateMap(state: MapEdit): string[] {
  const list = Object.values(state.nodes);
  const issues: string[] = [];
  const starts = list.filter((node) => node.kind === "start");
  if (starts.length !== 1) issues.push("開始が1つ必要");
  const bosses = list.filter(isBoss);
  if (bosses.length !== 1) {
    issues.push("ボスが1つ必要");
    return issues;
  }
  const missedBoss = list.filter((node) => !reachableFrom(state.nodes, node.id).has(bosses[0].id));
  if (missedBoss.length > 0) issues.push(`ボスに届かない: ${missedBoss.map((node) => node.id).join(", ")}`);
  if (starts.length === 1) {
    const missedStart = idsMissing(list, reachableFrom(state.nodes, starts[0].id));
    if (missedStart.length > 0) issues.push(`開始から届かない: ${missedStart.join(", ")}`);
  }
  return issues;
}
